import { CONTENT_TYPES, getResourceContentType } from '@/utils/content-type';
import { Resource } from '@edwin-group/cj-graphql';
import PodcastCard from './Podcast';
import GenericResourceCard from './GenericResource';

const ResourceCard = ({
  resource,
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  resource: Resource;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  const type = getResourceContentType(resource?.attributes?.resourceType?.data?.attributes?.type);

  if (type === CONTENT_TYPES.PODCAST) {
    return (
      <PodcastCard
        resource={resource}
        showBookmarkIcon={showBookmarkIcon}
        onRemoveFromBookmark={onRemoveFromBookmark}
      />
    );
  }

  return (
    <GenericResourceCard
      resource={resource}
      showBookmarkIcon={showBookmarkIcon}
      onRemoveFromBookmark={onRemoveFromBookmark}
    />
  );
};

export default ResourceCard;
